<template>
  <transition name="fade">
    <div>
      <b-button
        class="btn-info p-2 px-3 radius-10 text-center"
        style="min-height: 47px; min-width: 330px"
        v-b-modal.extraPackageForm
      >
        <p class="d-inline-block text-left m-0">
          <span class="d-block">
            <b-icon icon="calendar2-check" />
            <strong class="pl-2">Fishing Experience with Paul</strong>
          </span>
        </p>
      </b-button>

      <!-- MODAL FORM -->
      <extra-package-modal />
    </div>
  </transition>
</template>

<script>
import ExtraPackageModal from './ExtraPackageModal'

export default {
  name: 'ExtraButton',
  components: {
    ExtraPackageModal,
  },
}
</script>

<style scoped></style>
